import React, { useEffect, useState } from 'react'
import styles from "./template.module.css"
import { adjustTextByIndentation, openLinkExternal, parseInlineFormatting } from '../../../../utils/utils'
import Button from '../../../Form/Button'
import { TbArrowBackUp, TbCopy, TbExternalLink, TbMaximize, TbPhone } from 'react-icons/tb'
import Location from '../Location'
import Image from '../Image'
import Video from '../Video'
import Document from '../Document'
import Download from '../Download'

const Template = ({ content, showPreview, templatePreview = false, openPreview, downloadMedia, highlightQuery = "" }) => {
    const [srcMedia, setSrcMedia] = useState()
    const [bodyExpanded, setBodyExpanded] = useState(false)
    const textOptions = {
        renderWhatsAppEmojis: Boolean(showPreview),
        highlightQuery,
    }

    const bodyText = content?.body?.text || ""
    const canCollapseBody = templatePreview && (bodyText.length > 420 || bodyText.split("\n").length > 8)

    useEffect(() => {
        setBodyExpanded(false)
    }, [bodyText, templatePreview])

    useEffect(() => {
        let objectUrl

        try {
            if (content?.header?.file && (content?.header?.file instanceof Blob || content?.header?.file instanceof File)) {
                objectUrl = URL.createObjectURL(content?.header?.file)
                setSrcMedia(objectUrl)
            } else if (content?.url) {
                if (content?.header?.format === "IMAGE") {
                    setSrcMedia(showPreview ? content?.urlThumb || content?.url : content?.url || content?.urlThumb)
                } else {
                    setSrcMedia(content?.url)
                }
            } else if (content?.header?.handle) {
                setSrcMedia(content?.header?.handle)
            } else {
                setSrcMedia()
            }
        } catch (err) {
            setSrcMedia()
        }

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl)
        }
    }, [content, showPreview])

    const getHeaderByTemplate = (header) => {
        switch (header?.format) {
            case "TEXT":
                return <span>{parseInlineFormatting(header?.text || "", undefined, textOptions)}</span>
            case "IMAGE":
                return srcMedia ?
                    <Image
                        url={srcMedia}
                        width={header?.width}
                        height={header?.height}
                        showPreview={showPreview}
                        openPreview={openPreview}
                    />
                    :
                    <Download
                        downloading={content?.downloading}
                        downloadMedia={downloadMedia}
                    />
            case "VIDEO":
                return srcMedia ?
                    <Video
                        url={srcMedia}
                        showPreview={showPreview}
                        openPreview={openPreview}
                    />
                    :
                    <Download
                        downloading={content?.downloading}
                        downloadMedia={downloadMedia}
                    />
            case "DOCUMENT":
                return srcMedia ?
                    <Document
                        name={content?.header?.filename || content?.header?.file?.name}
                        url={srcMedia}
                    />
                    :
                    <Download
                        downloading={content?.downloading}
                        downloadMedia={downloadMedia}
                    />
            case "LOCATION":
                return <Location
                    latitude={header?.location?.latitude || "0"}
                    longitude={header?.location?.longitude || "0"}
                />
            default:
                return <span></span>
        }
    }

    const getButtonByType = (button, index) => {
        const Icon = getIconByTypeButton(button?.type)
        return (
            <Button
                key={index}
                className={styles.button}
                {...getButtonAction(button)}
            >
                {Icon && <Icon />} {button?.text || "Botão"}
            </Button>
        )
    }

    const getIconByTypeButton = (type) => {
        switch (type) {
            case "QUICK_REPLY":
                return TbArrowBackUp
            case "URL":
                return TbExternalLink
            case "PHONE_NUMBER":
                return TbPhone
            case "COPY_CODE":
                return TbCopy
            default:
                return
        }
    }

    const getButtonAction = (button) => {
        switch (button.type) {
            case "URL":
                return {
                    onClick: () => openLinkExternal(getLinkByButton(button))
                }

            case "QUICK_REPLY":
                return {
                    onClick: () => onQuickReply(button.payload)
                }

            case "PHONE_NUMBER":
                return {
                    onClick: () => openLinkExternal(`tel:${button.phone_number}`)
                }

            default:
                return {}
        }
    }

    const getLinkByButton = (button) => {
        const { type, url, value } = button

        if (type !== "URL" || !url) return null

        if (value !== undefined && value !== null) {
            return url.replace("{{1}}", value)
        }

        return url
    }

    const onQuickReply = (payload) => {
        console.log("onQuickReply", payload)
    }

    return (
        <div className={`${styles.container} ${templatePreview ? styles.templatePreview : ""}`}>
            {content?.header &&
                <div className={`${styles.header} ${templatePreview && content?.header?.format === "IMAGE" ? styles.imageHeaderPreview : ""} ${templatePreview && content?.header?.format === "VIDEO" ? styles.videoHeaderPreview : ""}`}>
                    {getHeaderByTemplate(content.header)}
                    {templatePreview && ["IMAGE", "VIDEO"].includes(content?.header?.format) && srcMedia && typeof openPreview === "function" &&
                        <button
                            type="button"
                            className={styles.expandMedia}
                            aria-label="Visualizar mídia em tela cheia"
                            title="Visualizar em tela cheia"
                            onClick={(event) => {
                                event.preventDefault()
                                event.stopPropagation()
                                openPreview(true)
                            }}
                        >
                            <TbMaximize />
                        </button>
                    }
                </div>
            }
            {showPreview && <>
                {content?.body &&
                    <div className={styles.body}>
                        <span className={`${styles.bodyText} ${canCollapseBody && !bodyExpanded ? styles.bodyTextCollapsed : ""}`}>
                            {adjustTextByIndentation(bodyText, undefined, textOptions)}
                        </span>
                        {canCollapseBody && !bodyExpanded &&
                            <button
                                type="button"
                                className={styles.readMore}
                                aria-expanded="false"
                                onClick={(event) => {
                                    event.preventDefault()
                                    event.stopPropagation()
                                    setBodyExpanded(true)
                                }}
                            >
                                Ver mais
                            </button>
                        }
                    </div>
                }
                {content?.footer &&
                    <div className={styles.footer}>
                        <span>{adjustTextByIndentation(content?.footer?.text || "", undefined, textOptions)}</span>
                    </div>
                }
                {content?.buttons?.length > 0 &&
                    <div className={styles.buttons}>
                        {content.buttons.map(getButtonByType)}
                    </div>
                }
            </>}
        </div>
    )
}

export default Template
